import superagent from 'superagent';
import superagentUse from 'superagent-use';
import prefix from 'superagent-prefix';

const unauthorizedRedirect = function authRedirect(req) {
  req.on('response', (res) => {
    if (res.status === 401) {
      const redirectUrl = 'https://api.purecars.com/account/login?returnUrl=https://adpreview.purecars.com/';
      window.location.assign(redirectUrl);
    }
  });
};

const useWithCredentials = (request) => request.withCredentials();

const agent = superagentUse(superagent);
agent.use(unauthorizedRedirect);
agent.use(prefix('https://api.purecars.com'));
agent.use(useWithCredentials);

export default agent;



// WEBPACK FOOTER //
// ./src/utils/http.js